module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/vehicle-e1d3f7fbd58deb77ac4a137d9fbd7de8.svg";